var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_story",
    "data-name": "vuesax/outline/story",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "story"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.632,23.414A11.555,11.555,0,0,1,3.4,19.985a11.773,11.773,0,0,1,0-16.56,11.6,11.6,0,0,1,16.457,0,11.773,11.773,0,0,1,0,16.56A11.555,11.555,0,0,1,11.632,23.414Zm0-20.909A9.1,9.1,0,0,0,5.166,5.2a9.269,9.269,0,0,0,0,13.014,9.115,9.115,0,0,0,12.933,0A9.269,9.269,0,0,0,18.1,5.2,9.1,9.1,0,0,0,11.632,2.5Z",
    transform: "translate(8.368 8.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.714,20.115a1.536,1.536,0,0,1-.468-.084A17.791,17.791,0,0,1,2.4,12.354,17.729,17.729,0,0,1,.155,1.1a1.256,1.256,0,1,1,2.492.318,15.345,15.345,0,0,0,1.924,9.668,15.228,15.228,0,0,0,7.594,6.591,1.278,1.278,0,0,1,.7,1.639A1.238,1.238,0,0,1,11.714,20.115Z",
    transform: "translate(2.086 17.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.25,6.055A1.248,1.248,0,0,1,.269,5.57,1.24,1.24,0,0,1,.485,3.814a17.715,17.715,0,0,1,21.79-.134,1.258,1.258,0,0,1,.233,1.756,1.239,1.239,0,0,1-1.745.234,15.257,15.257,0,0,0-18.749.117A1.218,1.218,0,0,1,1.25,6.055Z",
    transform: "translate(8.528 2.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.259,20.1a1.257,1.257,0,0,1-.468-2.425,15.308,15.308,0,0,0,7.594-6.591,15.129,15.129,0,0,0,1.924-9.668A1.256,1.256,0,1,1,12.8,1.1a17.86,17.86,0,0,1-2.241,11.257,17.8,17.8,0,0,1-8.849,7.678A1.832,1.832,0,0,1,1.259,20.1Z",
    transform: "translate(24.941 17.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H40V40H0Z",
    transform: "translate(40 40) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVission);
export default __webpack_public_path__ + "static/media/vission.10b7c6cb73d1fcab770d6f02f356a467.svg";
export { ForwardRef as ReactComponent };